import React from 'react';
import { Box, Skeleton } from '@mui/material';

const VideoInfoSkeleton = () => {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Box className="group" sx={{ display: 'flex', width: '100%' }}>
        <Skeleton width="80%" height={30} />
        <Box
          sx={{
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            ml: 2,
            mr: 7,
            width: 24,
            height: 24
          }}
        >
          <Skeleton variant="circular" width={24} height={24} />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
        <Skeleton width="80%" height={20} />
      </Box>
      <Box sx={{ mt: 0.5 }}>
        <Skeleton width="75%" height={20} />
      </Box>
    </Box>
  );
};

export default VideoInfoSkeleton;
